function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgBanheiros = function SvgBanheiros(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M22.096 24.957l-.542 3.946h2.007a.5.5 0 110 1H8.18a.5.5 0 110-1h4.476C8.33 27.03 5.254 22.728 5.064 17.67c-.865-.005-1.564-.724-1.564-1.598V3.098c0-.877.704-1.598 1.572-1.598h6.219c.869 0 1.572.72 1.572 1.598v12.974c0 .21-.04.413-.115.598h1.145c.003-1.208.469-2.248 1.284-2.248H27.6c.818 0 1.284 1.047 1.284 2.26a.51.51 0 010 .012.5.5 0 01-.154.976h-.964c-.206 3.46-2.533 6.339-5.671 7.287zm-1.042.238c-.396.062-.801.094-1.214.094a.5.5 0 010-1c.56 0 1.105-.068 1.627-.196a.497.497 0 01.11-.029c2.84-.75 4.978-3.299 5.188-6.394H6.064c.256 6.25 5.281 11.233 11.437 11.233h3.044l.509-3.708zm6.831-8.525c-.002-.716-.24-1.248-.284-1.248H15.177c-.044 0-.281.532-.284 1.248h12.992zm-16.594 0a.589.589 0 00.572-.598V3.098a.589.589 0 00-.572-.598H5.072a.59.59 0 00-.572.598v12.974c0 .33.261.598.572.598H11.291z"
  }));
};

SvgBanheiros.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgBanheiros.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgBanheiros;